import detailApiCall from './detail'
import listApiCall from './list'

const ApiCall = {
  detail: detailApiCall,
  list: listApiCall
}

export default ApiCall
